import { Icon, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolMailboxMessage } from "@virtual-brain-lib/types";

export function MailRow({ message }: { readonly message: MessageToolMailboxMessage }) {
	const { subject, attachments } = message;

	return (
		<div className="flex min-w-0 items-center gap-1.5 px-1 py-0.5">
			<Icon color="defaultLight" name="envelop" size="xs" />
			<Span className="truncate text-default" variant="body-xs">
				{subject}
			</Span>
			{attachments && attachments.length > 0 && (
				<Icon
					className="shrink-0"
					color="defaultLight"
					name="paperclip"
					size="xs"
					tooltip={{
						children: attachments.map((attachment) => attachment.name).join(", "),
					}}
				/>
			)}
		</div>
	);
}
